<template>
  <div v-if="itemView">
    <div class="panel-title" :class="itemView.PanelClass || 'panel-title'">
      <a
        :data-parent="'#' + accordionParentName"
        data-toggle="collapse"
        :href="'#accordionItem' + itemView.ID"
        aria-expanded="false"
      >
        <span class="open-sub"></span>
        {{ itemView.Title }}
      </a>
    </div>

    <div
      :id="'accordionItem' + itemView.ID"
      class="panel-collapse collapse"
      role="tablist"
      aria-expanded="false"
    >
      <div class="panel-content">
        <div class="item" v-if="itemView.Obj">
          <div class="row">
            <div class="col-md-12">
              <div class="font-18 mt-0 mb-30 no-style notranslate">
                <vue-markdown
                  :name="'markdown' + itemView.Obj.id"
                  class="markdownVideoLink"
                  :source="itemView.Obj.Description"
                ></vue-markdown>
              </div>
            </div>
            <div
              class="col-md-6"
              v-if="itemView.Obj.Gallery != null && itemView.Obj.Gallery.length > 0"
            >
              <h5 class="text-uppercase mt-0 mb-10 letter-space-2">
                Galleria:
              </h5>
              <div
                class="gallery-isotope grid-2 gutter-small clearfix"
                data-lightbox="gallery"
              >
                <div
                  class="gallery-item"
                  v-for="(img, index) in itemView.Obj.Gallery"
                  :key="img.id"
                >
                  <a
                    :href="baseUrl + img.url"
                    :title="'Immagine - ' + (index + 1)"
                    data-lightbox="gallery-item"
                  >
                    <img :src="baseUrl + img.url" :alt="img.alternativeText" />
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-md-6"
              v-if="itemView.Obj.Videos != null && itemView.Obj.Videos.length > 0"
            >
              <h5 class="text-uppercase mt-0 mb-10 letter-space-2">Video:</h5>
              <div class="row">
                <div
                  class="col-md-12"
                  v-for="(vid, index) in itemView.Obj.Videos"
                  :key="vid.id"
                >
                  <video
                    preload="metadata"
                    width="100%"
                    controls
                    :title="'Video - ' + (index + 1)"
                  >
                    <source :src="baseUrl + vid.url" :type="vid.mime" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          :id="'secondLevel' + itemView.ID"
          v-if="itemView.Items"
          class="panel-group accordion"
        >
          <div class="panel" v-for="item in itemView.Items" :key="item.ID">
             <program-detail-item
              :name="'thirthLevel' + item.ID"
              v-bind:itemView="item"
              v-bind:accordionParentName="'secondLevel' + itemView.ID"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sub-panel-title a {
  color: #ee163b;
}

.thirth-panel-title a {
  color: #b3b3b3;
}
</style>

<script>
import VueMarkdown from "vue-markdown";
import ProgramDetailItem from "../auth/ProgramDetailItem.vue";
export default {
  name: "program-detail-item",
  props: ["itemView", "accordionParentName"],
  components: {
    VueMarkdown,
    ProgramDetailItem
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {},
};
</script>
